<!--
This components makes heavy use of  VeeValidate (https://baianat.github.io/vee-validate/) for form validation
-->

<template>
  <div>
    <b-field v-if="showBasicInfo" grouped  class="columns">
      <b-field label="Drivers License No."  expanded class="column" :type="calculateFieldType('Drivers License')">
        <b-input v-model="carrierInfo.carrierCommercialDriverLicenseNumber"
                 name="drivers license"
                 expanded
                 v-validate="{required: true}"
                 required
                 autofocus></b-input>
      </b-field>
      <b-field label="MC/DOT Number" expanded class="column" :type="calculateFieldType('DOT Number')">
        <b-input v-model="carrierInfo.carrierMotorCarrierNumber"
                 name="DOT Number"
                 expanded
                 v-validate="{required: true}"
                 required></b-input>
      </b-field>
    </b-field>

    <b-field v-if="showBasicInfo" grouped  class="columns">
      <b-field label="Date of Birth"  expanded class="column" :type="calculateFieldType('date of birth')">
        <b-datepicker v-model="carrierInfo.carrierDateOfBirth"
                      name="date of birth"
                      :date-formatter="dateFormatter"
                      required
                      v-validate="{required: true}">
        </b-datepicker>
        <!--
        <date-picker class="input"
                     v-model="carrierInfo.carrierDateOfBirth"
                     name="date of birth"
                     required
                     v-validate="{required: true}"
                     :config="datePickerOptions"/>
        -->
      </b-field>
      <b-field label="Truckl Instant Pay" expanded class="column">
        <div class="input">
          <b-tooltip
            label="Low flat rate, EFS fuel cards, 24/7 online access, no collection hassle, no billing hassle, second credit checks."
            type="is-dark"
            animated
            multilined>
            <span class="info-icon-wrapper">
              <font-awesome-icon icon="info-circle" size="lg" />
            </span>
          </b-tooltip>
          <b-tooltip
            label="Click to view terms and conditions"
            type="is-dark"
            animated>
            <a class="info-icon-wrapper" @click="toggleIpTerms">
              <font-awesome-icon icon="file-signature" size="lg" />
            </a>
          </b-tooltip>
          <b-switch v-model="carrierInfo.carrierAlwaysFactorFlag" :class="{ 'is-size-7': isPrePopulated }">
            Provides  immediate pay, with less to worry about.
          </b-switch>
        </div>
        Move the switch above  to the right, if you always want to use factoring or leave In position, if you would like to be asked  whether to use factoring  for each new load.
      </b-field>
    </b-field>

    <b-field v-if="showEquipmentInfo" class="columns is-multiline">
      <label class="label column is-full">
        Equipment Information
      </label>

      <b-field expanded class="column" label="Truck make & model">
        <div class="select" :class="calculateFieldType('truck make and model')">
          <select class="select" v-model="carrierInfo.carrierEquipmentTruckManufacturer"
                  name="truck make and model"
                  v-validate="{required: true}"
                  required>
            <option v-for="item in equipmentMake" :key="item">
              {{ item }}
            </option>
          </select>
        </div>
      </b-field>

      <b-field expanded class="column" label="Build year of your truck" :type="calculateFieldType('truck year')">
        <b-input v-model.number="carrierInfo.carrierEquipmentTruckYear"
                 type="number"
                 name="truck year"
                 v-validate="{required: true}"
                 required></b-input>
      </b-field>

      <b-field expanded class="column" label="Trailer type">
        <div class="select" :class="calculateFieldType('trailer type')">
          <select v-model="carrierInfo.carrierEquipmentTrailerDescription1"
                  name="trailer type"
                  v-validate="{required: true}"
                  required>
            <option v-for="item in equipmentList" :key="item">
              {{ item }}
            </option>
          </select>
        </div>
      </b-field>

      <b-field expanded class="column" label="Any other trailer type">
        <div class="select">
          <select v-model="carrierInfo.carrierEquipmentTrailerDescription2">
            <option v-for="item in equipmentList" :key="item">
              {{ item }}
            </option>
          </select>
        </div>
      </b-field>
    </b-field>

    <b-field v-if="showInsuranceInfo" class="columns is-multiline">
      <label class="label column is-full">
        Insurance Information
      </label>

      <b-field expanded class="column" label="Insurance Issuer" :type="calculateFieldType('insurance company')">
        <b-input v-model="carrierInfo.carrierInsurancePolicyCompanyName"
                 name="insurance company"
                 v-validate="{required: true}"
                 required></b-input>
      </b-field>

      <b-field expanded class="column" label="Policy Number" :type="calculateFieldType('policy number')">
        <b-input v-model="carrierInfo.carrierInsurancePolicyNumber"
                 name="policy number"
                 v-validate="{required: true}"
                 required></b-input>
      </b-field>

      <b-field expanded class="column" label="Effective Date" >
        <b-datepicker v-model="carrierInfo.carrierInsurancePolicyEffectiveTimestamp"
                      name="effective date"
                      :class="calculateFieldType('effective date')"
                      :date-formatter="dateFormatter"
                      required
                      v-validate="{required: true}">
        </b-datepicker>
        <!--
        <date-picker class="input"
                     :class="calculateFieldType('effective date')"
                     v-model="carrierInfo.carrierInsurancePolicyEffectiveTimestamp"
                     name="effective date"
                     required
                     v-validate="{required: true}"
                     :config="datePickerOptions"/>
        -->
      </b-field>

      <b-field expanded class="column" label="Is your insurance active?">
        <b-field>
          <b-radio-button v-model="carrierInfo.carrierInsurancePolicyActiveFlag"
                          :native-value="false">
            No
          </b-radio-button>

          <b-radio-button v-model="carrierInfo.carrierInsurancePolicyActiveFlag"
                          :native-value="true">
            Yes
          </b-radio-button>
        </b-field>
      </b-field>
    </b-field>

    <b-field v-if="showDocumentsInfo" class="columns is-multiline">
      <div class="column is-full">
        <label class="label">
          Upload Your Documents
        </label>
        <small>If you do not have these available right now you can complete your registration and upload these at a later date.</small>
      </div>

      <b-field v-for="file in filesToUpload" :key="file.filename"  expanded class="column card file">
        <b-upload v-model="rawFiles[file.fieldName]" drag-drop>
          <a class="button is-yellow">
            <b-icon icon="upload"></b-icon>
            <span>{{ file.displayName }}</span>
          </a>
        </b-upload>
        <div class="file-name" v-if="rawFiles[file.fieldName]">
          {{ rawFiles[file.fieldName].name }}
        </div>
      </b-field>

    </b-field>

    <pdf-viewer :show.sync="showIpTerms"
                file-path="/documents/instant-pay-terms.pdf"
                :is-link="true"
                file-name="Truckl Instant Pay"></pdf-viewer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DatePicker from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import equipmentList from '@/lookup-data/equipment-list.json'
import equipmentMake from '@/lookup-data/equipment-makes.json'
import getBase64 from '@/helpers/fileToBase64'
import { format } from 'date-fns'
import { isEmpty, merge } from 'lodash-es'

import PdfViewer from '@/components/ModalDisplayPdf'

import carrierFileUploads from '@/lookup-data/carrier-file-uploads'

export default {
  name: 'CarrierInfo',

  model: {
    prop: 'existingCarrierInfo',
    event: 'input'
  },

  props: {
    showBasicInfo: {
      type: Boolean,
      default: true
    },

    showEquipmentInfo: {
      type: Boolean,
      default: true
    },

    showInsuranceInfo: {
      type: Boolean,
      default: true
    },

    showDocumentsInfo: {
      type: Boolean,
      default: true
    },

    existingCarrierInfo: {
      type: Object,
      default: () => {}
    }
  },

  mounted() {
    if (this.isPrePopulated) {
      this.carrierInfo = merge({}, this.carrierInfo, this.existingCarrierInfo)
      this.carrierInfo.carrierDateOfBirth = new Date(this.carrierInfo.carrierDateOfBirth)
      this.carrierInfo.carrierInsurancePolicyEffectiveTimestamp = new Date(
        this.carrierInfo.carrierInsurancePolicyEffectiveTimestamp
      )
    }
  },

  data() {
    return {
      equipmentList: equipmentList,
      equipmentMake: equipmentMake,
      showIpTerms: false,
      carrierInfo: {
        accountKey: null,
        carrierCommercialDriverLicenseNumber: '',
        carrierMotorCarrierNumber: '',
        carrierAlwaysFactorFlag: false,
        carrierDateOfBirth: null,
        carrierInsurancePolicyCompanyName: '',
        carrierInsurancePolicyEffectiveTimestamp: null,
        carrierInsurancePolicyActiveFlag: true,
        carrierInsurancePolicyNumber: '',
        carrierEquipmentTruckManufacturer: '',
        carrierEquipmentTruckYear: '',
        carrierEquipmentTrailerDescription1: '',
        carrierEquipmentTrailerDescription2: ''
      },
      filesToUpload: carrierFileUploads,
      rawFiles: {},
      documents: {}
    }
  },

  computed: {
    ...mapGetters('user', { isUserLoggedIn: 'isLoggedIn', accountInfo: 'accountInfo' }),

    isPrePopulated() {
      return !isEmpty(this.existingCarrierInfo) && this.existingCarrierInfo.accountKey
    },

    carrierPayload() {
      let payload = {
        ...this.carrierInfo,
        carrierDateOfBirth: this.dateParser(this.carrierInfo.carrierDateOfBirth),
        carrierInsurancePolicyEffectiveTimestamp: this.dateParser(
          this.carrierInfo.carrierInsurancePolicyEffectiveTimestamp
        ),
        accountKey: this.accountInfo.accountKey
      }

      if (this.showDocumentsInfo) {
        payload = {
          carrier: payload,
          documents: this.documents
        }
      }

      return payload
    },

    /**
     * Config object for the date picker
     * @returns {Object}
     */
    datePickerOptions() {
      return {
        mode: 'single',
        altInput: true,
        dateFormat: 'Z',
        altFormat: 'F d, Y'
      }
    }
  },

  components: {
    DatePicker,
    PdfViewer
  },

  methods: {
    dateFormatter(date) {
      return format(date, 'MMMM DD, YYYY')
    },

    dateParser(date) {
      return format(date, 'YYYY-MM-DDTHH:mm:ssZ')
    },

    async processFile(category, file) {
      const extension = file.name.split('.').pop()
      const filename = `${category}.${extension}`

      return {
        documentName: filename,
        documentHolder: 'account',
        documentType: 'carrier_document',
        documentHolderKey: this.accountInfo.accountKey,
        documentData: await getBase64(file)
      }
    },

    toggleIpTerms() {
      this.showIpTerms = !this.showIpTerms
    },

    async validate() {
      return this.$validator.validate()
    },

    /**
     *
     * @param {String} fieldName The name of the field in question (this is the name given to vee-validate)
     * @returns {string} CSS class to be applied
     */
    calculateFieldType(fieldName) {
      // TODO: this might make a good candidate for a mix-in
      return this.validationErrors.has(fieldName) ? 'is-danger' : ''
    },

    async notify() {
      const isValid = this.$validator.errors.items.length === 0

      // wasn't able to figure out how to use v-validate with document upload fields, so doing that check manually
      const isComplete = isValid && this.carrierInfo.carrierInsurancePolicyActiveFlag

      this.$emit('input', this.carrierPayload)
      this.$emit('isComplete', isComplete)
    }
  },

  watch: {
    rawFiles: {
      deep: true,
      async handler() {
        this.filesToUpload.forEach(async (file) => {
          if (this.rawFiles[file.fieldName] && !this.documents[file.fieldName]) {
            this.documents[file.fieldName] = await this.processFile(file.fileName, this.rawFiles[file.fieldName])
          }
        })
      }
    },
    validationFields: {
      deep: true,
      handler: 'notify'
    },
    documents: {
      deep: true,
      handler: 'notify'
    },
    'carrierInfo.carrierInsurancePolicyActiveFlag': 'notify',
    'carrierInfo.carrierAlwaysFactorFlag': 'notify'
  }
}
</script>

<style scoped lang="scss">
.info-icon-wrapper {
  margin-right: 8px;
}

.label {
  padding-bottom: 0;
  margin-bottom: 0;
}

.select {
  display: block;
  select {
    width: 100%;
  }
}

.field.file {
  width: 100%;
  flex-direction: column;
  align-items: center;

  label.upload.control {
    display: block;
    text-align: center;
  }

  .file-name {
    border-width: 0;
  }

  .button {
    background: #fcbf45;
  }
}
</style>
